import { Component, Input } from '@angular/core';
import { AuditTrialDetails } from '../../shared/models/audits/audit-trial-details';
import { SessionTransitionDetails } from '../models/session-transition-details';
import { SessionLifeCycle } from '../models/session-life-cycle';
import { SessionAuditTrialDetails } from '../models/session-audit-trial-details';
import { SessionAuditService } from '../services/session-audit.service';
import { MessageService } from 'primeng/api';
import { SharedConstants } from '../../shared/constants/shared-constants';

@Component({
  selector: 'app-session-audit-trial',
  templateUrl: './session-audit-trial.component.html',
  styleUrls: ['./session-audit-trial.component.scss']
})
export class SessionAuditTrialComponent {
  @Input() sessionId: string = '';
  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  sessionTransitionDetails!: SessionTransitionDetails;
  sessionLifeCycleDetails: SessionLifeCycle[] = [];
  sessionAuditSummaryDetails: SessionAuditTrialDetails[] = [];
  showLoader:boolean = false;
  isSessionAuditDetailsDataLoaded = false;
  constructor(private sessionAuditService: SessionAuditService, private messageService: MessageService) {

  }
  ngOnInit(): void {
    this.showLoader = true;
    this.sessionAuditService.getSessionTransitionDetails(this.sessionId)
      .subscribe({
        next: (sessionTransitionDetails) => {
        this.sessionTransitionDetails = sessionTransitionDetails;
        this.sessionLifeCycleDetails = sessionTransitionDetails.sessionLifeCycleDetails;
        this.sessionAuditSummaryDetails = sessionTransitionDetails.sessionAuditTrialDetails;
        this.auditAttributeDetailsOfTransaction = sessionTransitionDetails.sessionAuditTrialDetails[0];
        this.isSessionAuditDetailsDataLoaded = true;
        this.notifyMissingAttributesIfAny();
        this.showLoader = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: SharedConstants.Severity_Error,
          summary: SharedConstants.Audit_Fail_Error_Message,
          sticky: true
        });
        this.showLoader = false;
      }
    });
  }
  showAuditItemDetails = (auditAttributeDetails: any) => {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }

  private hasMissingAttributes(): boolean {
    const summary = this.sessionAuditSummaryDetails;
    return !!summary?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }
  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }
}
